import Cookies from 'js-cookie';
import { KEY_MYGPT_TOKEN, WebSocketClient, WebSocketClientInstance } from '@mygpt/app';
let webSocketClientInstance: WebSocketClientInstance | null = null;

const initAdminWebSocket = () => {
  if (webSocketClientInstance) {
    return webSocketClientInstance;
  }

  const token = (Cookies.get(KEY_MYGPT_TOKEN()) || '').replace('Bearer ', '');

  const APIBaseURL = window.ENV.GBASE_SUPPORT_FRONTEND_VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL;
  // 移除 APIBaseURL 中的协议前缀，避免 wss://https// 双重协议问题
  const wsHost = APIBaseURL.replace(/^https?:\/\//, '').replace(/^http?:\/\//, '');
  let url = `wss://${wsHost}/notification/admin/ws?token=${token}`;

  // local 模式（nginx 反代）或本地开发走 vite 代理（VITE_API_BASE_URL=/api）时，
  // base 是相对路径，需要用当前域名 + /api 前缀建立 ws 连接
  if (import.meta.env.VITE_MODE === 'local' || APIBaseURL.startsWith('/')) {
    url = `wss://${window.location.host}/api/notification/admin/ws?token=${token}`;
  }

  const webSocketClient = new WebSocketClient({
    url,
    reconnectInterval: 5000,
    maxReconnectAttempts: 3,
    connectionTimeout: 10000,
  });

  webSocketClient.on('error', (error) => {
    // console.error('WebSocket encountered an error:', error);
  });

  webSocketClient.on('close', (event) => {
    // console.log('WebSocket connection closed:', event);
  });

  webSocketClientInstance = webSocketClient;

  return webSocketClient;
};

initAdminWebSocket();

export const getAdminWebSocket = () => {
  if (!webSocketClientInstance) {
    throw new Error('WebSocket未初始化，请先调用initAdminWebSocket');
  }
  return webSocketClientInstance;
};
